import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { Input, Select, FallbackImage, Render, Button, DocUpload, DatePicker, PaperClip, Viewer } from 'components';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { UserIcon, CancelCircleIcon, CheckCircleIcon, EyeIcon, UploadIcon } from 'assets/icons';
import moment from 'moment';
import { AssistantService } from 'services';

interface Props extends RootState, RouteComponentProps<any> {
	dispatch: any
}

const STEPS = {
	FILES: 1,
	DATA: 2
}

const TABS = {
	INFO: 1,
	DOCUMENTS: 2
}

class Create extends React.Component<Props> {

	state = {
		form: {
			photo_file: null,
			dni_file: null,
			name: '',
			lastname: '',
			birthdate: '',
			document: '',
			nationality_id: '',
			birth_city: '',
			email: '',
			phone: '',
			gender: '',
			city: '',
			medical_certificate: {
				expiration_date: '',
				file: ''
			},
			food_handling: {
				expiration_date: '',
				file: ''
			}
		},
		step: this.props.match.params?.id == null ? STEPS.FILES : STEPS.DATA,
		tab: TABS.INFO,
		visible: false,
		file: '',
		nationalities: [],
		assistant: null,
		session_id: null,
		type: null,
		dni_blob: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: `${ this.props.match.params?.id ? 'Editar' : 'Registrar' } ayudante`,
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async () => {
		const res: any = await AssistantService.getData({
			assistant_id: this.props.match.params?.id
		});
		this.setState({
			nationalities: res.nationalities || []
		},() => {
			if (!res.assistant && this.props.match.params?.id) {
				this.props.history.replace('/');
			}
			else if (res.assistant) {
				const medical_certificate = res.assistant?.files?.find((i: any) => i.type == Constants.ASSISTANT_FILES.MEDICAL_CERTIFICATE);
				const food_handling = res.assistant?.files?.find((i: any) => i.type == Constants.ASSISTANT_FILES.FOOD_HANDLING);

				this.setState({
					form: {
						...this.state.form,
						name: res.assistant?.name || '',
						lastname: res.assistant?.lastname || '',
						city: res.assistant?.city || '',
						email: res.assistant?.email || '',
						birth_city: res.assistant?.birth_city || '',
						gender: res.assistant?.gender || '',
						birthdate: res.assistant?.birthdate ? moment(res.assistant?.birthdate).toDate() : '',
						document: res.assistant?.document || '',
						phone: res.assistant?.phone || '',
						nationality_id: res.assistant?.nationality_id || '',
						medical_certificate: {
							...this.state.form.medical_certificate,
							expiration_date: medical_certificate?.expiration_date ? moment(medical_certificate?.expiration_date).toDate() : ''
						},
						food_handling: {
							...this.state.form.food_handling,
							expiration_date: food_handling?.expiration_date ? moment(food_handling?.expiration_date).toDate() : ''
						}
					},
					assistant: res.assistant
				});
			}
		});
	}

	onChange = async (value: any, target: keyof typeof this.state.form) => {
		if (target == 'dni_file') {
			const res: any = await AssistantService.readFile({
				hasFile: true,
				file: value,
				user_id: this.props.user?.id,
				assistant_id: this.props.match.params?.id || '',
			});
			if (!res.data.result) {
				Globals.showError("El documento cargado no corresponde al formato requerido o no es válido. Por favor, sube el documento solicitado para continuar.");
				this.setState({
					form: {
						...this.state.form,
						photo_file: null
					}
				});
				return;
			}
			await this.setState({
				session_id: res.session_id,
				form: {
					...this.state.form,
					name: res.data?.name || '',
					lastname: res.data?.lastname || '',
					document: res.data?.document || '',
					nationality_id: res.data?.nationality_id || '',
					birthdate: res.data?.birthdate ? moment(res.data?.birthdate).toDate() : '',
				}
			});
		}

		this.setState({
			form: {
				...this.state.form,
				[target]: value
			}
		},async () => {
			if (target == 'dni_file') {
				// @ts-ignore
				const dni_blob = this.state.form.dni_file ? URL.createObjectURL(this.state.form.dni_file) : null;
				// @ts-ignore
				const dni_file = this.state.assistant?.files?.find((i: any) => i.type == Constants.ASSISTANT_FILES.ID)?.file;
				const _dni_file = (this.state.form.dni_file ? dni_blob : (Constants.BASE_STORAGE + dni_file));
				const _result = await fetch(_dni_file);
				const type = _result.headers.get('content-type');
				this.setState({
					type,
					dni_blob
				});
			}
		});
	}

	submit = async () => {
		await AssistantService.save({
			hasFile: true,
			...this.state.form,
			// @ts-ignore
			medical_certificate: this.state.form?.medical_certificate?.file?.value,
			// @ts-ignore
			food_handling: this.state.form?.food_handling?.file?.value,
			birthdate: this.state.form.birthdate && moment(this.state.form.birthdate).format('YYYY-MM-DD'),
			medical_certificate_expiration_date: this.state.form.medical_certificate?.expiration_date && moment(this.state.form.medical_certificate?.expiration_date).format('YYYY-MM-DD'),
			food_handling_expiration_date: this.state.form.food_handling?.expiration_date && moment(this.state.form.food_handling?.expiration_date).format('YYYY-MM-DD'),
			assistant_id: this.props.match.params?.id || '',
			user_id: this.props.user?.id,
			session_id: this.state.session_id || ''
		});
		Globals.showSuccess(`Se ha ${ this.props.match.params?.id ? 'modificado' : 'creado' } el ayudante correctamente`);
		this.props.history.goBack();
	}

	change = (e: any) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target?.name]: e.target?.value
			}
		});
	}

	next = async () => {
		const { form, step, tab } = this.state;

		switch(step) {
			case STEPS.FILES:
				if (!form.dni_file || !form.photo_file) {
					Globals.showError("Por favor, ingrese ambos archivos antes de continuar");
					return;
				}
				this.setState({
					step: STEPS.DATA
				});
			break;

			case STEPS.DATA:
				switch(tab) {
					case TABS.INFO:
						if (
							!form.birth_city ||
							!form.name ||
							!form.lastname ||
							!form.birthdate ||
							!form.document ||
							!form.birth_city ||
							!form.email ||
							!form.phone ||
							!form.gender ||
							!form.city ||
							!form.nationality_id
						) {
							Globals.showError("Para continuar, todos los datos son obligatorios");
							return;
						}

						if (!Globals.validateEmail(form.email)) {
							Globals.showError("El correo electrónico no es válido");
							return;
						}

						await AssistantService.check({
							...this.state.form,
							assistant_id: this.props.match.params?.id
						});

						this.setState({
							tab: TABS.DOCUMENTS
						});
					break;

					case TABS.DOCUMENTS:
						if (
							(form.medical_certificate?.file && !form.medical_certificate?.expiration_date)
						) {
							Globals.showError("Para continuar, ingrese la fecha de expiración del certificado de salud");
							return;
						}

						if (
							(form.food_handling?.file && !form.food_handling?.expiration_date)
						) {
							Globals.showError("Para continuar, ingrese la fecha de expiración de manipulación de alimentos");
							return;
						}

						if (!Globals.validateEmail(form.email)) {
							Globals.showError("El correo electrónico no es válido");
							return;
						}

						this.submit();
					break;
				}
			break;
		}
	}

	back = () => {
		const { step, tab } = this.state;

		switch(step) {
			case STEPS.FILES:
				this.props.history.replace(`/${ this.props.user?.level_id == Constants.LEVELS.CLIENT ? 'client' : 'moderators' }/assistants`);
			break;

			case STEPS.DATA:
				switch(tab) {
					case TABS.INFO:
						if (this.props.match.params?.id) {
							this.props.history.replace(`/${ this.props.user?.level_id == Constants.LEVELS.CLIENT ? 'client' : 'moderators' }/assistants`);
						}
						else {
							this.setState({
								step: STEPS.FILES
							});
						}
					break;

					case TABS.DOCUMENTS:
						this.setState({
							tab: TABS.INFO
						});
					break;
				}
			break;
		}
	}

	viewFile = (item: any) => {
	    if (!item) return;

	    const isPdf = 
	        item.toLowerCase().endsWith('.pdf') || 
	        item.startsWith('data:application/pdf') ||
	        (this.state.type === 'application/pdf');

	    if (isPdf) {
	        if (item.startsWith('data:application/pdf')) {
	            const blob = this.base64ToBlob(item, 'application/pdf');
	            const url = URL.createObjectURL(blob);
	            window.open(url, '_blank');
	        } else {
	            window.open(item, '_blank');
	        }
	    } else {
	        this.setState({
	            visible: true,
	            file: item
	        });
	    }
	}

	base64ToBlob = (dataURI: string, type: string) => {
	    const byteString = atob(dataURI.split(',')[1]);
	    const ab = new ArrayBuffer(byteString.length);
	    const ia = new Uint8Array(ab);
	    for (let i = 0; i < byteString.length; i++) {
	        ia[i] = byteString.charCodeAt(i);
	    }
	    return new Blob([ab], { type: type });
	}

	verifyDocument = async (file: string) => {
		let document_type_id = null;

		if (file == 'medical_certificate') {
			document_type_id = Constants.BRAVEALO_DOCUMENT_TYPES.HEALTH_CERTIFICATE;
		}
		else if (file == 'food_handling') {
			document_type_id = Constants.BRAVEALO_DOCUMENT_TYPES.FOOD_HANDLING;
		}

		const res: any = await AssistantService.readFile({
			hasFile: true,
			// @ts-ignore
			file: this.state.form[file].file?.value,
			user_id: this.props.user?.id,
			assistant_id: this.props.match.params?.id || '',
			document_type_id,
			ignore_document_expiration: true
		});
		if (!res.data.result || !res.data.expiration_date) {
			Globals.showError("El documento cargado no corresponde al formato requerido o no es válido. Por favor, sube el documento solicitado para continuar.");
			this.setState({
				form: {
					...this.state.form,
					[file]: {
						// @ts-ignore
						...this.state.form[file],
						file: null
					}
				}
			});
			return;
		}
		else {
			this.setState({
				form: {
					...this.state.form,
					[file]: {
						// @ts-ignore
						...this.state.form[file],
						expiration_date: res.data.expiration_date ? moment(res.data.expiration_date).toDate() : ''
					}
				}
			});
		}
	}

	render() {
		const { form, step, tab, visible, dni_blob } = this.state;
		const assistant: any = this.state.assistant;

		// @ts-ignore
		const photo_blob = form.photo_file ? URL.createObjectURL(form.photo_file) : null;

		const photo_file = assistant?.files?.find((i: any) => i.type == Constants.ASSISTANT_FILES.PHOTO)?.file;
		const dni_file = assistant?.files?.find((i: any) => i.type == Constants.ASSISTANT_FILES.ID)?.file;
		const medical_certificate = assistant?.files?.find((i: any) => i.type == Constants.ASSISTANT_FILES.MEDICAL_CERTIFICATE)?.file;
		const food_handling = assistant?.files?.find((i: any) => i.type == Constants.ASSISTANT_FILES.FOOD_HANDLING)?.file;

		const _dni_file = (form.dni_file ? dni_blob : (Constants.BASE_STORAGE + dni_file));
		const isPdf = _dni_file?.endsWith('.pdf') || (_dni_file?.startsWith('blob:') && this.state.type === 'application/pdf');

		return (
			<div id="assistants-create">
				<Viewer
			      visible={ visible }
			      onClose={ () => this.setState({ visible: false }) }
			      images={ [{ src: this.state.file }] }
			    />

				{
					step == STEPS.FILES && (
						<>
							<div className="container-white">
								<DocUpload
									label="Foto / Logo de Perfil"
									isRequired
									file={form.photo_file}
									showImage
									message1={ this.props.match.params?.id ? 'Modificar Foto (Opcional)' : 'Arrastre y suelte su imagen aquí' }
									accept="image/jpeg,image/png"
									onUpload={f => this.onChange(f, 'photo_file')}
								/>
								<DocUpload
									label="Cédula"
									isRequired
									file={form.dni_file}
									message1={ this.props.match.params?.id ? 'Modificar cédula (Opcional)' : 'Arrastre y suelte su archivo aquí' }
									message2={'Este documento debe ser legible.\nFormatos aceptados: JPG, PNG o PDF no debe superar los 10MB.'}
									onUpload={f => this.onChange(f, 'dni_file')}
								/>
							</div>

							<div className="text-right" style={{ maxWidth: '1000px', margin: '0 auto' }}>
								<div className="row row-buttons">
									<div className="col-md-6">
										<button className="btn" onClick={ () => this.props.history.replace(`/${ this.props.user?.level_id == Constants.LEVELS.CLIENT ? 'client' : 'moderators' }/assistants`) }>
											Atras
										</button>
									</div>
									<div className="col-md-6">
										<button className="btn btn-blue" onClick={ () => {
											this.next();
										} }>
											Continuar
										</button>
									</div>
								</div>
							</div>
						</>
					)
				}
				
				{
					step == STEPS.DATA && (
						<>
							<div className="container-tabs">
								<div className="row row-tabs">
									<div className="col-md-6">
										<button className={ `btn btn-blue ${ tab == TABS.INFO ? 'active' : '' }` } onClick={ () => {
											this.setState({ tab: TABS.INFO });
										} }>
											Información
										</button>
									</div>
									<div className="col-md-6">
										<button className={ `btn btn-blue ${ tab == TABS.DOCUMENTS ? 'active' : '' }` } onClick={ () => {
											this.setState({ tab: TABS.DOCUMENTS });
										} }>
											Documentos
										</button>
									</div>
								</div>
							</div>
							<div className="container-white">
								{
									tab == TABS.INFO && (
										<>
											<div className="row">
												<div className="col-md-6">
													<div className="photo-wrapper-file">
														<img
															src={form.photo_file ? photo_blob : (Constants.BASE_STORAGE + photo_file)}
															placeholder={UserIcon}
															className="fb-img"
														/>
													</div>
												</div>
												<div className="col-md-6">
													{
														isPdf ? (
												          <div style={{
												            width: '100%',
												            height: '250px',
												            overflow: 'hidden',
												            border: '1px solid #ccc',
												            marginBottom: '20px'
												          }}>
												            <iframe src={ form.dni_file ? dni_blob : (Constants.BASE_STORAGE + dni_file) } style={{ border: 'none', width: '100%', height: '406px', marginTop: '-56px' }} />
												          </div>
												        ) : (
															<div className="photo-wrapper-file document-photo">
																<img
																	src={form.dni_file ? dni_blob : (Constants.BASE_STORAGE + dni_file)}
																	className="fb-img"
																/>
															</div>
														)
													}
												</div>
												<div className="col-md-6">
													<div className="input-group">
														<Input
															required
															label="Nombres"
															value={form?.name}
															name="name"
															onChange={(e: any) => this.change(e)}
															notMui
															disabled={ true }
														/>
													</div>
													<div className="input-group">
														<Input
															required
															label="Apellidos"
															value={form?.lastname}
															name="lastname"
															onChange={(e: any) => this.change(e)}
															notMui
															disabled={ true }
														/>
													</div>
													<div className="input-group">
														<Input
															required
															type="number"
															label="Cédula"
															value={form?.document}
															name="document"
															onChange={(e: any) => this.change(e)}
															notMui
															disabled={ true }
														/>
													</div>
													<div className="input-group">
														<Select
															required
															name="nationality_id"
															label="Nacionalidad"
															onChange={ (e: any) => this.change(e) }
															value={ form.nationality_id }
															options={ this.state.nationalities.map((item: any) => {
																return {
																	value: item.id,
																	label: item.name
																}
															}) }
															disabled={ true }
														/>
													</div>
													<div className="input-group">
														<DatePicker
														  required
								                          label="Fecha de nacimiento"
								                          placeholder="Fecha"
								                          maxDate={moment().toDate()}
								                          onChange={(date: string) => {
								                            this.setState({
								                              form: {
								                              	...this.state.form,
								                              	birthdate: date
								                              }
								                            });
								                          }}
								                          value={form?.birthdate}
								                          disabled={ true }
								                        />
													</div>
												</div>
												<div className="col-md-6">
													<div className="input-group">
														<Input
															required
															label="Email"
															value={form?.email}
															name="email"
															onChange={(e: any) => this.change(e)}
															notMui
														/>
													</div>
													<div className="input-group">
														<Input
															required
															label="Lugar de Nacimiento"
															value={form?.birth_city}
															name="birth_city"
															onChange={(e: any) => this.change(e)}
															notMui
														/>
													</div>
													<div className="input-group">
														<Select
															required
															label="Sexo"
															name="gender"
															onChange={ (e: any) => this.change(e) }
															value={ form.gender }
															options={ [
																{ value: 'M', label: 'Masculino' },
																{ value: 'F', label: 'Femenino' },
															] }
														/>
													</div>
													<div className="input-group">
														<Input
															required
															type="number"
															maxLength={ 11 }
															label="Teléfono"
															value={form?.phone}
															name="phone"
															onChange={(e: any) => this.change(e)}
															notMui
														/>
													</div>
													<div className="input-group">
														<Input
															required
															label="Zona donde reside"
															value={form?.city}
															name="city"
															onChange={(e: any) => this.change(e)}
															notMui
														/>
													</div>
												</div>
											</div>

											{
												this.props.match.params?.id != null && (
													<div className="container-white">
														<DocUpload
															label="Foto / Logo de Perfil"
															isRequired
															file={form.photo_file}
															message1={ this.props.match.params?.id ? 'Modificar Foto (Opcional)' : 'Arrastre y suelte su imagen aquí' }
															accept="image/jpeg,image/png"
															onUpload={f => this.onChange(f, 'photo_file')}
														/>
														<DocUpload
															label="Cédula"
															isRequired
															file={form.dni_file}
															message1={ this.props.match.params?.id ? 'Modificar cédula (Opcional)' : 'Arrastre y suelte su archivo aquí' }
															message2={'Este documento debe ser legible.\nFormatos aceptados: JPG, PNG, o PDF no debe superar los 10MB.'}
															onUpload={f => this.onChange(f, 'dni_file')}
														/>
													</div>
												)
											}
										</>
									)
								}
								{
									tab == TABS.DOCUMENTS && (
										<>
											<div className="document-item">
												<div className="row">
													<div className="col-md-8">
														<div className="container-title-document">
															<p>Certificado de Salud</p>
															<img className={ (form.medical_certificate?.file || medical_certificate) ? 'active' : '' } src={ (form.medical_certificate?.file || medical_certificate) ? CheckCircleIcon : CancelCircleIcon } />
														</div>
													</div>
													<div className="col-md-4">
														<PaperClip
															className="btn-icon"
									                        successText="Adjuntar"
									                        pendingText="Adjuntar"
									                        value={''}
									                        formats={['png','jpg','pdf','jpeg']}
									                        onChange={(e: any) => {
								                        		this.setState({
									                              form: {
									                              	...this.state.form,
									                              	medical_certificate: {
									                              		...this.state.form.medical_certificate,
									                              		file: e.target
									                              	}
									                              }
									                            },() => this.verifyDocument('medical_certificate'));
									                        }}>
									                        Adjuntar
															<img src={ UploadIcon } />
									                    </PaperClip>
														<button className="btn btn-icon" disabled={ !this.state.form.medical_certificate?.file && !medical_certificate } onClick={ () => {
															// @ts-ignore
															this.viewFile(this.state.form.medical_certificate?.file?.dataURL || (Constants.BASE_STORAGE + medical_certificate))
														} }>
															Ver
															<img src={ EyeIcon } />
														</button>
													</div>
												</div>

												<DatePicker
						                          label="F. Expiración"
						                          placeholder="--_--"
						                          minDate={moment().add(1,'day').toDate()}
						                          disabled={ true }
						                          onChange={(expiration_date: string) => {
						                            // this.setState({
						                            //   form: {
						                            //   	...this.state.form,
						                            //   	medical_certificate: {
						                            //   		...this.state.form.medical_certificate,
						                            //   		expiration_date
						                            //   	}
						                            //   }
						                            // });
						                          }}
						                          value={this.state.form.medical_certificate?.expiration_date}
						                        />
						                    </div>

						                    <div className="document-item">
						                        <div className="row">
													<div className="col-md-8">
														<div className="container-title-document">
															<p>Manipulación de alimentos</p>
															<img className={ (form.food_handling?.file || food_handling) ? 'active' : '' } src={ (form.food_handling?.file || food_handling) ? CheckCircleIcon : CancelCircleIcon } />
														</div>
													</div>
													<div className="col-md-4">
														<PaperClip
															className="btn-icon"
									                        successText="Adjuntar"
									                        pendingText="Adjuntar"
									                        value={''}
									                        formats={['png','jpg','pdf','jpeg']}
									                        onChange={(e: any) => {
									                        	this.setState({
									                              form: {
									                              	...this.state.form,
									                              	food_handling: {
									                              		...this.state.form.food_handling,
									                              		file: e.target
									                              	}
									                              }
									                            },() => this.verifyDocument('food_handling'));
									                        }}>
									                        Adjuntar
															<img src={ UploadIcon } />
									                    </PaperClip>
														<button className="btn btn-icon" disabled={ !this.state.form.food_handling?.file && !food_handling } onClick={ () => {
															// @ts-ignore
															this.viewFile(this.state.form.food_handling?.file?.dataURL || (Constants.BASE_STORAGE + food_handling))
														} }>
															Ver
															<img src={ EyeIcon } />
														</button>
													</div>
												</div>

												<DatePicker
						                          label="F. Expiración"
						                          placeholder="--_--"
						                          minDate={moment().add(1,'day').toDate()}
						                          disabled={ true }
						                          onChange={(expiration_date: string) => {
						                            // this.setState({
						                            //   form: {
						                            //   	...this.state.form,
						                            //   	food_handling: {
						                            //   		...this.state.form.food_handling,
						                            //   		expiration_date
						                            //   	}
						                            //   }
						                            // });
						                          }}
						                          value={this.state.form.food_handling?.expiration_date}
						                        />
						                    </div>
										</>
									)
								}
							</div>
							<div className="text-right" style={{ maxWidth: '1000px', margin: '0 auto' }}>
								<div className="row row-buttons">
									<div className="col-md-6">
										<button className="btn" onClick={ () => this.back() }>
											Atras
										</button>
									</div>
									<div className="col-md-6">
										<button className="btn btn-blue" onClick={ () => this.next() }>
											Guardar
										</button>
									</div>
								</div>
							</div>
						</>
					)
				}
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Create);